import ResetPassword from './ResetPasswordContainer'

export default ResetPassword
